export const DETAILS_VIEW = {
  MAPPED: "MAPPED",
  RAW: "RAW",
};

export const DETAILS_VIEW_OPTIONS = [
  { value: DETAILS_VIEW.MAPPED, label: "Mapped" },
  { value: DETAILS_VIEW.RAW, label: "Raw" },
];

export const SUMMARY_TILES = [
  { key: "totalRows", label: "Total rows", color: "primary.main" },
  { key: "passedRows", label: "Passed", color: "success.dark" },
  { key: "failedRows", label: "Failed", color: "error.dark" },
  { key: "warningRows", label: "Warnings", color: "warning.darkest" },
  { key: "skippedRows", label: "Skipped", color: "text.primary" },
];

export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 20;
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

export const NO_DATA_MESSAGE = "No data found";

export const RAW_SO_LISTING_API_URL =
  "/joms/api/external/v1/plant-supply/raw-so-listing";

export const RAW_SO_LISTING_EXPORT_API_URL = `${RAW_SO_LISTING_API_URL}/export`;

export const RAW_HEADER_MAPPING_API_URL =
  "/fileengine/bulk/file/template/columns";

export const FILE_UPLOAD_DOWNLOAD_API_URL = "/joms/api/external/v1/file-upload";
